module.exports = __webpack_public_path__ + "img/empty.82dc6c29.svg";